const BatchSendExpert = {
  tableConfig: {
    // minWidth: 2050
    // showCheckbox: true
  },
  queryList: [
    {
      name: 'mFirstSubjectName',
      label: '一级学科',
      component: 'input'
    },
    {
      name: 'mSecondSubjectName',
      label: '二级学科',
      component: 'input'
    },
    {
      name: 'acTutorType',
      label: '导师类型',
      component: 'select',
      componentAttr: {
        options: [{
          value: 1,
          label: '博士生导师'
        }, {
          value: 2,
          label: '硕士生导师'
        }, {
          value: 3,
          label: '兼职博士生导师'
        }, {
          value: 4,
          label: '兼职硕士生导师'
        }, {
          value: 5,
          label: '行业导师'
        }, {
          value: 0,
          label: '其他'
        }]
      }
    },
    {
      name: 'techPosition',
      label: '技术职务',
      component: 'select',
      componentAttr: {
        options: BaseConfig.zyjszw
      }
    },
    {
      name: 'name',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'orgName',
      label: '单位',
      component: 'input'
    },
    {
      name: 'degreeCategoryName',
      label: '专业学位',
      component: 'input'
    },
    {
      name: 'degreeDomainName',
      label: '专业领域',
      component: 'input'
    }
  ],
  urlMap: {
    'select': {
      url: '/custom/sendPaper/canArrangeExpList',
      data: {
        paperIds: '{parentId}'
      }
    },
    batchSendReview: '/custom/sendPaper/relateSelectedExpert'
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'id',
      key: true
    },
    {
      name: 'name',
      label: '姓名',
      // width: 80,
      action: {
        type: 'dialog',
        footerHide: true,
        width: 800,
        addr: 'systemManage/expertEdit?{id}&readonly'
      }
    },
    {
      name: 'acTutorType',
      label: '导师类型',
      // width: 100,
      map: {
        0: '其他',
        1: '博士生导师',
        2: '硕士生导师',
        3: '兼职博士生导师',
        4: '兼职硕士生导师',
        5: '行业导师'
      }
    },
    {
      name: 'techPosition',
      label: '技术职务',
      // width: 120,
      map: {
        '0': '无',
        '01': '初级',
        '02': '中级',
        '03': '副高级',
        '04': '正高级',
        '05': '讲师(博士学位)',
        '06': '副教授',
        '07': '教授'
      }
    },
    {
      name: 'orgName',
      label: '单位'
    },
    {
      name: 'mFirstSubjectName',
      // width: 150,
      label: '一级学科'
    },
    {
      name: 'mSecondSubjectName',
      // width: 150,
      label: '二级学科'
    },
    {
      name: 'degreeCategoryName',
      // width: 150,
      label: '专业学位'
    },
    {
      name: 'degreeDomainName',
      // width: 150,
      label: '专业领域'
    },
    {
      name: 'phone',
      // width: 120,
      label: '联系电话'
    },
    {
      name: 'email1',
      label: '邮箱'
    },
    {
      name: 'operation',
      label: '操作',
      width: 100,
      // fixed: 'right',
      actionList: [
        {
          label: '指派',
          name: 'batchSend',
          kind: 'primary', // error
          type: 'request',
          method: 'post',
          data: {
            paperIdList: '("{parentId}").split(",")',
            expId: '{id}',
            extSendFlag: '0'
          },
          addr: 'batchSendReview'
        },
        {
          label: '加送',
          name: 'batchSend',
          kind: 'error', // error
          type: 'request',
          method: 'post',
          data: {
            paperIdList: '("{parentId}").split(",")',
            expId: '{id}',
            extSendFlag: '1'
          },
          addr: 'batchSendReview'
        }
      ]
    }
  ]
}
export default BatchSendExpert



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/batchSendExpert.js